'use client'
import React from 'react'

import type { LinkDef } from '@hanzo/ui/types'
import { NavItems } from '@hanzo/ui/primitives'

  // NavItems styles each item via a callback, and a callback cannot cross the
  // server/client boundary. Creating it here keeps Footer itself on the server.
const FooterNav: React.FC<{
  items: LinkDef[]
  currentAs?: string
  className?: string
}> = ({
  items,
  currentAs,
  className = ''
}) => (
  <NavItems
    items={items}
    currentAs={currentAs}
    as='nav'
    className={className}
    itemClx={(def: LinkDef) => ((def.variant === 'linkFG') ?
      'font-nav text-[15px]/[1.3] font-medium tracking-normal text-muted-1 sm:hover:text-foreground transition-color duration-500'
      :
      'text-[15px]/[1.1] font-normal tracking-[0.2px] text-muted-1 sm:hover:text-foreground transition-color duration-500'
    )}
  />
)

export default FooterNav
